
// メッセージ
export module ConstMessage {
    // エラーメッセージ
    export const ERR_LOGIN = 'ログインに失敗しました。';
    export const ERR_CONNECT_NETWORK = 'ネットワークに接続できません。';
    export const ERR_GET_DATA = 'データの取得に失敗しました。';
    export const ERR_GET_EVENT_HISTORY = 'イベント参加履歴を取得できません。';
    export const ERR_GET_POINT_INFO = '保有ポイント情報を取得できません。';
    export const ERR_GET_POINT_HISTORY = 'ポイント履歴を取得できません。';
};
